module.exports = __webpack_public_path__ + "img/black_share.4b3158d6.png";